import { Action, Reducer } from 'redux';
import {
  DamageCategoryActionTypes,
  DamageCategoryState,
  DamageCategoryTypes
} from './damageCategoryTypes';

export const INITIAL_STATE: DamageCategoryState = {
  damageCategories: {
    data: null,
    errorMessages: null,
    isError: false,
    isLoading: false
  }
};

const damageCategoryReducer: Reducer<DamageCategoryState> = (
  state: DamageCategoryState = INITIAL_STATE,
  action: Action
) => {
  const actionTypes = action as DamageCategoryActionTypes;
  switch (actionTypes.type) {
    case DamageCategoryTypes.GET_DAMAGE_CATEGORIES:
      return {
        ...state,
        damageCategories: { ...state.damageCategories, isLoading: true }
      };
    case DamageCategoryTypes.SAVE_DAMAGE_CATEGORIES:
      return {
        ...state,
        damageCategories: {
          ...state.damageCategories,
          isLoading: false,
          errorMessages: actionTypes.payload.errorMessages,
          isError: actionTypes.payload.isError,
          data: actionTypes.payload.data
        }
      };
    case DamageCategoryTypes.RESET_REDUCER_DAMAGE_CATEGORIES:
      return {
        ...state,
        damageCategories: INITIAL_STATE.damageCategories
      };
    default:
      return state;
  }
};

export default damageCategoryReducer;
